/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StorageHeaterUIDTOV0 } from './storageHeaterUIDTOV0';
import { MeasurementUIDTOV0 } from './measurementUIDTOV0';
import { SAPSolarCollectorOvershadingCodeUIDTOV0 } from './sAPSolarCollectorOvershadingCodeUIDTOV0';
import { SAPCompassDirectionCodeUIDTOV0 } from './sAPCompassDirectionCodeUIDTOV0';
import { SAPVerticalPitchCodeUIDTOV0 } from './sAPVerticalPitchCodeUIDTOV0';


export interface RdSAPHeatingUIDTOV0 { 
    /**
     * Indicates if mains gas is available.
     */
    mainGasAvailable?: boolean;
    /**
     * The type of electricity meter present.
     */
    electricMeter?: string;
    /**
     * The heating proportion for the main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1HeatingProportion?: number;
    /**
     * The main heating number for system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1MainHeatingNumber?: string;
    /**
     * Data source for the primary heating system type of main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1SystemType?: string;
    /**
     * The subtype of the heating system for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1SystemSubType?: string;
    /**
     * The type of fuel used by main heating system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1Fuel?: string;
    /**
     * The heating system code for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1System?: string;
    /**
     * The type of controls for main heating system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1Controls?: string;
    /**
     * The flue type for the boiler of main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1FlueType?: string;
    /**
     * Indicates if main system 1 is fan-assisted [DEPRECATED Put into an object in array].
     */
    mainSystem1FanAssisted?: boolean;
    /**
     * The type of heat emitter for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1Emitter?: string;
    /**
     * The age category of the central heating pump for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1PumpAge?: string;
    /**
     * The emitter temperature for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1FlowTemp?: string;
    /**
     * Indicates if main system 1 has weather compensation [DEPRECATED Put into an object in array].
     */
    mainSystem1WeatherCompensation?: boolean;
    /**
     * Indicates if an MCS-installed heat pump is present for main system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1MCSInstalled?: boolean;
    /**
     * The PCDF ID for main heating system 1 [DEPRECATED Put into an object in array].
     */
    mainSystem1PCDFId?: number;
    /**
     * Whether Flue Gas Heat Recovery System is present
     */
    mainSystem1HasFGHRS?: boolean;
    mainSystem1FghrsPvPeakPower?: MeasurementUIDTOV0;
    mainSystem1FghrsOrientation?: SAPCompassDirectionCodeUIDTOV0;
    mainSystem1FghrsPvPitch?: SAPVerticalPitchCodeUIDTOV0;
    mainSystem1FghrsPvOvershading?: SAPSolarCollectorOvershadingCodeUIDTOV0;
    /**
     * The ID of the controller from the product database.
     */
    mainSystem1compensatingControllerIndexNumber?: number | null;
    /**
     * The ID of the time and temperature zone control from the product database.
     */
    mainSystem1TTZCIndexNumber?: number | null;
    /**
     * index number of heat network, if applicable, community space heating or community space and water heating.
     */
    mainSystem1communityHeatNetworkIndexNumber?: number | null;
    mainSystem1StorageHeaters?: Array<StorageHeaterUIDTOV0>;
    /**
     * The heating proportion for the main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2HeatingProportion?: number;
    /**
     * The main heating number for system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2MainHeatingNumber?: string;
    /**
     * Data source for the primary heating system type of main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2SystemType?: string;
    /**
     * The subtype of the heating system for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2SystemSubType?: string;
    /**
     * The type of fuel used by main heating system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2Fuel?: string;
    /**
     * The heating system code for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2System?: string;
    /**
     * The type of controls for main heating system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2Controls?: string;
    /**
     * The flue type for the boiler of main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2FlueType?: string;
    /**
     * Indicates if main system 2 is fan-assisted [DEPRECATED Put into an object in array].
     */
    mainSystem2FanAssisted?: boolean;
    /**
     * The type of heat emitter for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2Emitter?: string;
    /**
     * The age category of the central heating pump for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2PumpAge?: string;
    /**
     * The emitter temperature for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2FlowTemp?: string;
    /**
     * Indicates if main system 2 has weather compensation [DEPRECATED Put into an object in array].
     */
    mainSystem2WeatherCompensation?: boolean;
    /**
     * Indicates if an MCS-installed heat pump is present for main system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2MCSInstalled?: boolean;
    /**
     * The PCDF ID for main heating system 2 [DEPRECATED Put into an object in array].
     */
    mainSystem2PCDFId?: number;
    /**
     * Whether Flue Gas Heat Recovery System is present
     */
    mainSystem2HasFGHRS?: boolean;
    mainSystem2FghrsPvPeakPower?: MeasurementUIDTOV0;
    mainSystem2FghrsOrientation?: SAPCompassDirectionCodeUIDTOV0;
    mainSystem2FghrsPvPitch?: SAPVerticalPitchCodeUIDTOV0;
    mainSystem2FghrsPvOvershading?: SAPSolarCollectorOvershadingCodeUIDTOV0;
    /**
     * The ID of the controller from the product database.
     */
    mainSystem2compensatingControllerIndexNumber?: number | null;
    /**
     * The ID of the time and temperature zone control from the product database.
     */
    mainSystem2TTZCIndexNumber?: number | null;
    /**
     * index number of heat network, if applicable, community space heating or community space and water heating.
     */
    mainSystem2communityHeatNetworkIndexNumber?: number | null;
    mainSystem2StorageHeaters?: Array<StorageHeaterUIDTOV0>;
    /**
     * The type of fuel for secondary heating [DEPRECATED Put into an object in array].
     */
    secoundaryHeatingFuel?: string;
    /**
     * The type of secondary heating system [DEPRECATED Put into an object in array].
     */
    secoundaryHeatingSystem?: string;
    /**
     * The type of water heating system.
     */
    waterHeatingSystem?: string;
    /**
     * The type of fuel for water heating.
     */
    waterHeatingFuel?: string;
    /**
     * The size category of the hot water cylinder.
     */
    cylinderDetailsSize?: string;
    /**
     * The type of insulation for the hot water cylinder.
     */
    cylinderDetailsInsulation?: string;
    /**
     * The thickness of the hot water cylinder insulation.
     */
    cylinderDetailsThickness?: string;
    /**
     * The type of immersion heating present in the hot water cylinder.
     */
    cylinderDetailsImmersion?: string;
    /**
     * Indicates if a thermostat is present on the hot water cylinder.
     */
    cylinderDetailsStart?: boolean;
    /**
     * The number of rooms with a bath and/or non-mixer shower.
     */
    bathAndShowerRoomsWithBathAndOrNonMixerShower?: number;
    /**
     * The number of rooms with a bath and mixer shower.
     */
    bathAndShowerRoomsWithMixerShowerAndBath?: number;
    /**
     * The number of rooms with a mixer shower and no bath.
     */
    bathAndShowerRoomsWithMixerShowerNoBath?: number;
}
export namespace RdSAPHeatingUIDTOV0 {
}


